import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	title: {
		id: 'cross-join-nudges.request-access-prompt-flag.title',
		defaultMessage: 'Your team is now using {product}',
		description: 'Title of invite prompt flag to join Confluence or Jira',
	},
	titleReminder: {
		id: 'cross-join-nudges.request-access-prompt-flag.title-reminder',
		defaultMessage: 'Your team is working in {product}',
		description: 'Title of invite prompt flag to join Confluence or Jira',
	},
	titleNotInterested: {
		id: 'cross-join-nudges.request-access-prompt-flag.title-not-interested',
		defaultMessage: 'Your team is waiting for you in {product}',
		description: 'Title of invite prompt flag to join Confluence or Jira',
	},
	descriptionJira: {
		id: 'cross-join-nudges.request-access-prompt-flag.description-jira',
		defaultMessage:
			'Stay on top of your tasks, unify your project workflow and track your team progress in Jira.',
		description: 'Description of how Jira can be used to assist with Confluence projects',
	},
	joinButton: {
		id: 'cross-join-nudges.request-access-prompt-flag.join-button',
		defaultMessage: 'Join your team',
		description: 'Action to direct access or request access to Confluence or Jira',
	},
	remindMeLaterButton: {
		id: 'cross-join-nudges.request-access-prompt-flag.remind-me-later-button',
		defaultMessage: 'Remind me later',
		description: 'Title of the dismiss button in the request access prompt flag',
	},
	notInterestedButton: {
		id: 'cross-join-nudges.request-access-prompt-flag.not-interested-button',
		defaultMessage: 'Not interested',
		description:
			'Title of the dismiss button with a stronger tone in the request access prompt flag',
	},
});
